import React from 'react';
import TrustLayout from './TrustLayout';
import { PRODUCT_NAME } from '../../config/appBranding';

export default function StatusPage() {
  // v1: a truthful static status. A live status page hooked to real
  // health checks lands once the hosting provider's uptime monitor
  // is wired up (tracked separately).
  const lastChecked = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <TrustLayout title="Status" eyebrow="Trust">
      <div className="status-indicator" role="status">
        <span className="status-indicator__dot" aria-hidden="true" />
        <span>All systems operational</span>
      </div>

      <p>
        {PRODUCT_NAME} does not have a live uptime page yet. This page is updated manually when
        something meaningful changes &mdash; planned maintenance, extended incidents, or
        postmortems. Last checked {lastChecked}.
      </p>

      <h2>Current state</h2>
      <ul>
        <li><strong>Web app</strong> &mdash; operational</li>
        <li><strong>API</strong> &mdash; operational</li>
        <li><strong>Database</strong> &mdash; operational</li>
        <li><strong>Weekly digest delivery</strong> &mdash; operational</li>
      </ul>

      <h2>During an incident</h2>
      <p>
        If you&rsquo;re seeing something broken and this page still reads &ldquo;operational,&rdquo;
        email <a href="mailto:support@vizionops.com">support@vizionops.com</a>{' '}
        &mdash; we&rsquo;ll update this page within the hour.
      </p>

      <h2>Planned maintenance</h2>
      <p>
        None planned. We will announce scheduled maintenance at least 48 hours in advance by email to account admins and here.
      </p>

      <div className="trust__callout">
        <strong>On the roadmap:</strong> a live status page with per-component uptime history.
      </div>
    </TrustLayout>
  );
}
